<template>
  <v-data-table
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasRespondidas"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    item-key="perguntaMunicipioId"
    v-if="!isSala"
  >
    <template v-slot:item="props">
      <tr :class="'evidenciar'">
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td>
          <div>
            <div>{{ props.item.texto }}</div>
            <div
              v-if="getRespostaNumericaInfo(props.item)"
              class="resposta-numerica-info"
            >
              {{ getRespostaNumericaInfo(props.item) }}
            </div>
          </div>
        </td>
        <td>{{ props.item.pontos }}</td>
        <td width="300px">
          <v-form
            ref="file"
            lazy-validation
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              v-if="
                isFullAdmin ||
                (groupsConfig.enviarRespondidas && config.enviarRespondidas)
              "
              :rules="rules"
              multiple
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </v-form>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              v-if="
                isFullAdmin ||
                (groupsConfig.enviarRespondidas && config.enviarRespondidas)
              "
              color="primary"
              class="ml-3"
              @click="sendEvidences(props.item)"
            >
              <span>Enviar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia && props.item.evidenciada === false">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            v-if="props.item.evidencia.length > 0"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
  <respondidas-selo
    v-else
    :visualizarPontosMedalha="visualizarPontosMedalha"
    :headers="headers"
    :headersSemPontos="headersSemPontos"
    :perguntasRespondidas="perguntasRespondidas"
    :payload="payload"
    :expanded="expanded"
    :rulesArquivo="rules"
    :evidences="evidences"
    @sendEvidences="sendEvidences"
    @openEvidence="openEvidence"
    @load="loadEvidences"
    @enviarAnalise="(e) => salvarDadosComplementares(e, true)"
  ></respondidas-selo>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { sortArrayAsc } from "../../../../helpers/utils";
import RespondidasSelo from "./selo/RespondidasSelo.vue";
import Swal from "sweetalert2";
import { getRespostaNumericaInfo as buildRespostaNumericaInfo } from "./utils";
import { confirmarAnaliseIaUpload } from "./preAnaliseUpload";

export default {
  components: {
    AppModalShowEvidence,
    RespondidasSelo,
  },
  data() {
    return {
      rules: [
        (files) => {
          if (files && Array.isArray(files)) {
            var somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);

            return somaTotal > 209715200
              ? "Total de arquivos não pode ser maior que 200MB!"
              : true;
          } else if (files && !Array.isArray(files)) {
            return files.size > 209715200
              ? "Arquivo não pode ser maior que 200MB!"
              : true;
          }

          return !files;
        },
      ],
      headers: [
        { text: "Tema", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        {
          text: "Pontos",
          value: "pontos",
        },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia", sortable: false },
      ],
      headersSemPontos: [
        { text: "Tema", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        { text: "", value: "", sortable: false },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia", sortable: false },
      ],
      payload: {},
      municipioId: this.$route.params.id,
      perguntasRespondidas: [],
      allPerguntas: [],
      user: JSON.parse(localStorage.getItem("user")),
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      expanded: [],
      evidences: [],
      sortBy: ["nome"],
      sortDesc: [false],
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
    visualizarPontosMedalha: false,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        else this.perguntasRespondidas = this.allPerguntas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    getRespostaNumericaInfo(question) {
      return buildRespostaNumericaInfo(question);
    },
    async loadAnsweredQuestions(question, analise) {
      this.setLoading(true);
      cityQuestionAPI
        .getRespondidas(this.municipioId)
        .then(async (resp) => {
          this.perguntasRespondidas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.nome, b.nome) || sortArrayAsc(a.texto, b.texto)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasRespondidas = this.perguntasRespondidas.filter(
              (item) =>
                this.user.permissoes.some(
                  (per) =>
                    per.eixoId === item.eixoId &&
                    per.municipioId === item.municipioId
                )
            );
          }

          this.allPerguntas = this.perguntasRespondidas;

          if (this.filter.temas.length > 0) {
            this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }

          if (question) {
            this.openEvidence(question, true);
          } else {
            if (analise)
              this.$notification.success("Evidência enviada para análise");

            this.setLoading(false);
          }
        })
        .catch((er) => {
          console.log("Erro ao listas perguntas respondidas: ", er);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    check(arquivos) {
      if (arquivos) {
        const arquivosSelecionados = Array.isArray(arquivos)
          ? arquivos
          : [arquivos];
        var somaTotal = arquivosSelecionados.reduce((a, b) => {
          return a + (b.size || 0);
        }, 0);

        return somaTotal > 209715200 ? false : true;
      }

      return true;
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    async sendEvidences(question, analise) {
      if (!this.isSala) {
        const valid = this.check(question.arquivos);
        if (!valid) return;
      }
      const dadosComple = question.perguntaId == 3;

      if (this.isSala) {
        if (
          !question.arquivosDados &&
          !question.arquivos &&
          !analise &&
          dadosComple
        ) {
          this.salvarDadosComplementares(question, analise);
          return;
        }
      }
      if (!question.arquivos && !question.videoUrl && !this.isSala) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        if (Array.isArray(question.arquivos)) {
          if (question.arquivos && question.arquivos.length) {
            for (let i = 0; i < question.arquivos.length; i++) {
              formData.append("arquivos", question.arquivos[i]);
            }
          }
        } else if (question.arquivos) {
          formData.append("arquivos", question.arquivos);
        }

        if (question.arquivosDados) {
          question.arquivosDados = this.renameFile(
            question.arquivosDados,
            "DADOS_COMPLE_" + question.arquivosDados.name
          );

          formData.append("arquivos", question.arquivosDados);
        }

        // Adicionar URL do vídeo se fornecida
        if (question.videoUrl) {
          formData.append("videoUrl", question.videoUrl);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);
        const prosseguir = await confirmarAnaliseIaUpload(
          formData,
          (value) => this.setLoading(value),
          this.config,
          this.groupsConfig
        );
        if (!prosseguir) return;

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso", {
              success: {
                background: "#483D8B",
                color: "#fff",
              },
            });
            if (this.isSala) {
              this.salvarDadosComplementares(question, analise);
            } else this.loadAnsweredQuestions();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    salvarDadosComplementares(pergunta, analise) {
      this.setLoading(true);
      delete pergunta.arquivos;
      delete pergunta.arquivosDados;
      delete pergunta.evidence;

      pergunta.salvo = true;
      if (analise) pergunta.evidenciada = true;
      cityQuestionAPI
        .put(pergunta)
        .then((resp) => {
          this.loadAnsweredQuestions(analise ? null : pergunta, analise);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar Pergunta");
        });
    },
    openEvidence(evidenceSlot, deixarAberto) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item.perguntaId === evidenceSlot.perguntaId && !deixarAberto) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }

      if (this.expanded.length > 0) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(this.expanded[0].perguntaMunicipioId)
          .then((resp) => {
            this.evidences = resp.data.evidencias;
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      } else {
        this.setLoading(false);
      }
    },
    loadEvidences() {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(this.expanded[0].perguntaMunicipioId)
        .then((resp) => {
          this.evidences = resp.data.evidencias;
          this.loadAnsweredQuestions();
        })
        .catch(() => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
  },

  mounted() {
    this.loadAnsweredQuestions();
    if (this.isSala) {
      this.headers = [
        { text: "Pilar", value: "nome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "", value: "", sortable: false },

        { text: "Evidência", value: "evidencia" },
      ];

      this.headersSemPontos = [
        { text: "Pilar", value: "nome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "", sortable: false },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "pergunta.evidencia", sortable: false },
        { text: "", value: "", sortable: false },
      ];
    } else {
      this.headers = [
        { text: "Tema", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        {
          text: "Pontos",
          value: "pontos",
        },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
      ];
    }
  },
  computed: {
    ...mapGetters(["isSala", "isAnalista", "isFullAdmin", "isParceiro"]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.resposta-numerica-info {
  color: #666;
  font-size: 11px;
  line-height: 1.3;
  margin-top: 4px;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
